import React from "react";
import Entities from "../../components/Entities";

function summarize(ids) {
  if (!ids) return "—";
  const count = ids.split(",").filter(Boolean).length;
  return count === 0 ? "—" : `${count} selected`;
}

const schema = {
  fields: [
    { name: "Manufacturer", propertyName: "manufacturerName", search: true },
    {
      name: "Provinces",
      renderCell: (entity, i) => (
        <td key={i} className="text-muted small">{summarize(entity.provinceIds)}</td>
      ),
    },
    {
      name: "Banners",
      renderCell: (entity, i) => (
        <td key={i} className="text-muted small">{summarize(entity.bannerIds)}</td>
      ),
    },
    {
      name: "Products",
      renderCell: (entity, i) => (
        <td key={i} className="text-muted small">{summarize(entity.productIds)}</td>
      ),
    },
  ],
};

function ManufacturerPresets() {
  return <Entities shema={schema} />;
}

export default ManufacturerPresets;
